// extracted by mini-css-extract-plugin
export default {"addDeleteButtonContainer":"CreateTemplateTab_addDeleteButtonContainer__9CHUX"};